module.exports = __webpack_public_path__ + "img/shape-hex-orange.de2f2e17.png";